/**
 * Embed Route Wrapper
 * 
 * Wraps embed pages with EmbedAuthProvider and EmbedLayout.
 * Use this in routes.js for all embed-accessible pages.
 */

import React, { useEffect } from 'react';
import { EmbedAuthProvider } from '@/shared/contexts/EmbedAuthContext';
import EmbedLayout from '@/shared/layouts/EmbedLayout';
import { setupEmbedInterceptor } from '@/shared/utils/embedAxiosInterceptor';

export default function EmbedRoute({ children }) {
    // Setup interceptor immediately to ensure it's ready before any children mount/fetch
    setupEmbedInterceptor();

    return (
        <EmbedAuthProvider>
            <EmbedLayout>
                {children}
            </EmbedLayout>
        </EmbedAuthProvider>
    );
}

/**
 * HOC version for easier use in routes
 */
export function withEmbedAuth(Component) {
    return function EmbedWrappedComponent(props) {
        // Setup interceptor immediately
        setupEmbedInterceptor();

        return (
            <EmbedAuthProvider>
                <EmbedLayout>
                    <Component {...props} />
                </EmbedLayout>
            </EmbedAuthProvider>
        );
    };
}
